module.exports = __webpack_public_path__ + "img/47_1.80ec5f0f.png";